module.exports = __webpack_public_path__ + "img/icon7.3de03d37.png";